import { Box, Button, Container, List, ListItemText, Paper, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import { themePalette } from "../../config/theme.config";
import { RiForbid2Line } from "react-icons/ri";
import { useEffect, useState } from "react";

interface Props {
    messages?: Array<string>;
}

export const NoEditPage: React.FC<Props> = ({ messages = [] }) => {
    let history = useNavigate();
    const theme = useTheme();
    let [margin,setMargin] = useState(5);
    const handleGoBack = () => {
        history(-1);
    };
    const isXLargeScreen = useMediaQuery(theme.breakpoints.up('xl'));
    const isLargeScreen = useMediaQuery(theme.breakpoints.between('lg', 'xl'));
    const isMediumScreen = useMediaQuery(theme.breakpoints.between('md', 'lg'));
    const isSmallScreen = useMediaQuery(theme.breakpoints.between('sm', 'md'));
    const isXSmallScreen = useMediaQuery(theme.breakpoints.between('xs', 'sm'));
    const isXSmallDownScreen = useMediaQuery(theme.breakpoints.down('xs'));
    //#region UseEffect
    useEffect(() => {
        if (isXSmallScreen || isXSmallDownScreen) {
            setMargin(5);
            //console.log('xs');
        }else if (isSmallScreen) {
            setMargin(7);
            //console.log('sm');
        }else if (isMediumScreen) {
            setMargin(9);
            //console.log('md');
        }else if (isLargeScreen) {
            setMargin(10);
            //console.log('lg');
        }else if (isXLargeScreen) {
            setMargin(15);
            //console.log('xl');
        } else{
            setMargin(15);
            //console.log('other');
        }
    }, [isXSmallDownScreen,isXSmallScreen,isSmallScreen,isMediumScreen,isLargeScreen,isXLargeScreen]);
    //#endregion
    return (
        <Container sx={{ mt: margin, mb: margin, p: 1 }} maxWidth="md" style={{ border: `1px solid ${themePalette.NAVCOLOR}`, borderRadius: '5px', padding: '20px', borderTopWidth: '3px', textAlign: 'center', minHeight: '50vh' }}>
            <Box>
                <Typography variant="h3" color={themePalette.NAVCOLOR}>
                    No se puede editar
                </Typography>
                <br />
                <RiForbid2Line size={150} color="#FF0000"/>
                <br />
                {messages.length > 0 ?
                    <>
                        <Typography variant="body1" color={'#000000'}>
                            Lamentamos informarle que no tiene acceso a esta opción debido a las siguientes razones:
                        </Typography>
                        <List>
                            {messages.map((m,index) => (
                                <ListItemText key={'messages-'+index} primary={m} />
                            ))}
                        </List>
                    </>
                    : <>
                        <Typography variant="body1" color={'#000000'}>
                            Lamentamos informarle que no tiene acceso a esta opción.
                        </Typography>
                    </>}
            </Box>
            <br />
            <Button variant="contained" aria-label="delete" color="primary" onClick={handleGoBack}>
                VOLVER
            </Button>
        </Container>
    );
}